const vocab = require('../vocabs/search-lookup-vocabs.json')

function getVocabs(propName) {
    return vocab[propName];
}
module.exports = getVocabs;